<script setup lang="ts">
import { computed, ref } from "vue";
import { locale } from "../../../locale";
import ToolTip from "../../ToolTip.vue";
import { existSharingNotThisUser, isScreenSharing, selfScreenShare, startScreenShare, stopScreenShare } from "../../../states/screenShareState";

const disabled = computed(() => {
  // self на всякий случай если вдруг так вышло что ты тоже начал шарить
  return existSharingNotThisUser() && !selfScreenShare.value;
});
const clicked = ref(false)
const changeScreenShare = () => {
  clicked.value = true
  setTimeout(() => {clicked.value = false},2000)
  if (!isScreenSharing()) {
    startScreenShare();
  } else if(selfScreenShare.value) {
    stopScreenShare();
  }
};
const btn = ref<HTMLElement | null>(null);
</script>
<template>
  <button
    ref="btn"
    class="share-screen-btn"
    :disabled="disabled"
    @click="changeScreenShare"
    :class="{
      active:
        selfScreenShare,
      disabled: disabled,
    }"
  >
    <svg
      v-if="selfScreenShare"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.2002 19V5C1.2002 3.89543 2.09563 3 3.2002 3H20.8002C21.9048 3 22.8002 3.89543 22.8002 5V19C22.8002 20.1046 21.9048 21 20.8002 21H12.0002H3.2002C2.09563 21 1.2002 20.1046 1.2002 19Z"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M8.40039 9L15.6004 15M8.40039 15L15.6004 9"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-else
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.60019 10.7143L11.9972 8.14286M11.9972 8.14286V15.8571M11.9972 8.14286L14.4002 10.7143M12.0002 21H3.2002C2.09563 21 1.2002 20.1046 1.2002 19V5C1.2002 3.89543 2.09563 3 3.2002 3H20.8002C21.9048 3 22.8002 3.89543 22.8002 5V19C22.8002 20.1046 21.9048 21 20.8002 21H12.0002Z"
        :stroke="isScreenSharing() ? '#747474' : 'white'"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
    <ToolTip v-if="!clicked" :placement="'top'" :reference="btn">{{
      selfScreenShare
        ? locale.enddemonstarate
        : existSharingNotThisUser()
        ? locale.alreadydemonstrate
        : locale.startdemonstarte
    }}</ToolTip>
  </button>
</template>
<style scoped>
.share-screen-btn {
  width: 44px;
  height: 44px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  border-radius: 50px;
  background-color: #8dca35;
  border: none;
  cursor: pointer;
}

.share-screen-btn:hover {
  background-color: #a6dd57;
}

.share-screen-btn:active {
  background-color: #78b81c;
}

.share-screen-btn:disabled {
  user-select: none;
  cursor: default;
}

.share-screen-btn.active {
  background-color: #d51f26;
}

.share-screen-btn.active:hover {
  background-color: #e93f46;
}

.share-screen-btn.active:active {
  background-color: #ac2226;
}

.share-screen-btn.disabled {
  background-color: rgba(73, 73, 73, 0.85);
}

.share-screen-btn:focus {
  outline: none;
}
</style>
